function init() {



  const triggers = document.querySelectorAll(".js-modal-trigger");
  triggers.forEach((trigger) => {
    const modalSelector = trigger.getAttribute("data-target");
    if (modalSelector) {
      const modal = document.getElementById(modalSelector) as HTMLDialogElement;
      if (modal) {
        const closeBtn = modal.querySelector(".js-modal-close");
        trigger.addEventListener("click", () => {
          openDialog(modal);
        });

        if (closeBtn) {
          closeBtn.addEventListener("click", () => {
            closeDialog(modal);
          });
        }
        modal.addEventListener("close", () => {
          closeDialog(modal);
        });
        modal.addEventListener("cancel", () => {
          closeDialog(modal);
        });
      }
    }
  });
}

let scrollY: number;

function openDialog(dialog: HTMLDialogElement) {
  scrollY = window.scrollY;
  document.body.style.position = "fixed";
  document.body.style.top = `-${scrollY}px`;
  document.body.style.left = "0";
  document.body.style.right = "0";
  document.body.style.width = "100%";
  if (document.documentElement.scrollHeight > document.documentElement.clientHeight) {
    document.documentElement.style.scrollbarGutter = "stable";
  }
  dialog.showModal();
  dialog.dispatchEvent(new Event("show"));
}

function closeDialog(dialog: HTMLDialogElement) {
  if (dialog.open) {
    dialog.close();
  }
  document.body.style.position = "";
  document.body.style.top = "";
  document.body.style.left = "";
  document.body.style.right = "";
  document.body.style.width = "";
  document.documentElement.style.scrollbarGutter = "";
  window.scrollTo(0, scrollY);
}

export default init;
